import React, {Fragment, PureComponent} from 'react';

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx';

import chroImg from '../../../media/images/sub-universes/hr/chro.jpg?size=600';
import headerImg from '../../../media/images/universes/hr.jpg';
import payrollImg from '../../../media/images/sub-universes/hr/payroll.jpg?size=600';
import socialRelationsImg from '../../../media/images/sub-universes/hr/socialRelations.jpg?size=600';

const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition RH</strong>
    , Twineeds est la plateforme qu'il vous faut.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const ourJobsItems = [
  {
    title: 'Direction des Ressources Humaines',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour de la fonction <strong>' +
      'Direction de votre service Ressources Humaines</strong>.</p><p>Tout types de postes liés à cette fonction : ' +
      '<strong>Direction des Ressources Humaines, Responsable des Ressources Humaines</strong> etc.</p>',
    img: chroImg.src
  },
  {
    title: 'Gestion de la paie / SIRH',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du monde de la <strong>gestion de la ' +
      'paie et supports : gestionnaire de paie, responsable paie, chargé(e) de projet SIRH</strong> etc.</p>',
    img: payrollImg.src
  },
  {
    title: 'Affaires sociales',
    brief: '<p>Des profils de juristes pour <strong>renforcer vos équipes</strong> sur les problématiques liées aux ' +
      'affaires sociales : <strong>responsable des affaires sociales, responsable relations sociales</strong> etc.</p>',
    img: socialRelationsImg.src
  }
];

const specificDifference = <Fragment>
  <strong>Une large gamme de compétences dans les Ressources Humaines</strong>, quand les cabinets sont généralement
  spécialisés.
</Fragment>;

export default class LandingCompanyHr extends PureComponent {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      headerImgAlt="Directeurs des ressources humaines, MDT RH"
      metaTitle="Twineeds Ressources Humaines"
      metaDescription="Twineeds met en relation les entreprises avec les consultants indépendants, intérim managers et managers de transition sur la fonction Ressources humaines"
      metaOgTitle="Twineeds Manager de transition Ressources Humaines"
      metaOgDescription="Attirez les experts des Ressources humaines en conseil et management de transition grâce à la plateforme Twineeds"
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Besoin de spécialistes des Ressources Humaines ?"
      universeCode="hr"
    />;
  }
}
